import React, { useEffect, useState } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import './Recommendations.scss'
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import * as routes from  '../../routes/route'
import SearchBar from '../../components/SearchBar/SearchBar';
import RecommendationsTable from './RecommendationsTable/RecommendationsTable';
import moment from 'moment';
import { validateDate } from '../../utils/helpers/universalFunctions';
import DatePicker from '../../components/DatePicker/DatePicker';
import {ReactComponent as DownloadIcon} from '../../assets/images/downloads.svg';
import { downloadRecommendationsExcel, getRecommendations, getTherapistList } from '../../redux/actions/RecommendationActions/RecommendationAction';
import { downloadExcel } from '../../utils/helpers/downloadMedia';
import { CircularProgress } from '@mui/material';

const columns = [
  { id: 'name', label: 'Guest Name', sortingKey: 'first_name', sort: true, width: '160px' },
    { id: 'gender', label: 'Gender', sortingKey: 'gender', sort: true, width: '130px' },
    { id: 'assign_doctor', label: 'Doctor Name', sortingKey: 'assign_doctor', sort: true, width: '180px' },
    { id: 'room_no', label: 'Guest Room Number', sortingKey: 'room_no', sort: true, width: '200px' },
    { id: 'support_staff_name', label: 'Therapist Assigned', sortingKey: 'support_staff_name', sort: true, width: '230px' },
    { id: 'session_name', label: 'Session Name', sortingKey: 'session_name', sort: true, width: '200px' },
    { id: 'therapist_room', label: 'Therapy Room Name', sortingKey: 'therapist_room', sort: true, width: '200px' },
    { id: 'session_time', label: 'Session Time', sortingKey: 'session_time', sort: true, width: '200px' },
    { id: 'session_note', label: 'Session Notes', sortingKey: 'session_notes', sort: true, width: '500px' },
    { id: 'notes_recommendation', label: 'Therapist Notes', sortingKey: 'notes_recommendation', sort: true, width: '500px' },
  ];
  



  function Recommendations() {
    const {loading, recommendations, downloadLoader, loadingTherapistlist, therapistList} = useSelector(state=> state.recommendationsReducer)
    const [searchParams, setSearchParams] = useSearchParams()
    const [filter, setFilter] = useState({
      searchText: searchParams.get("search") || '',
      therapistName: searchParams.get("therapistName") || '',
      date: validateDate(searchParams.get("date")) ? new Date(searchParams.get("date")) : '',
      orderBy: searchParams.get("orderBy") || columns[0].sortingKey,
      order: searchParams.get("order") || 'asc'
    })

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const getTableData = ()=>{
      let sendData={
          searchText: searchParams.get("search") || '',
          therapistName: searchParams.get("therapistName") || '',
          date: validateDate(searchParams.get("date")) ? searchParams.get("date") : '',
          page: searchParams.get("page") ? parseInt(searchParams.get("page"))+1 : 1,
          pageLimit: searchParams.get("pageLimit") || 10,
          orderBy:  searchParams.get("orderBy") || columns[0].sortingKey,
          order:  searchParams.get("order") || 'asc',
      }
      dispatch(getRecommendations(sendData))
    }

    const downloadTableData = ()=>{
      const onSuccessCallback = (data)=>{
        downloadExcel({data, fileName: 'Therapist Session Report.xlsx'})
        }

      dispatch(downloadRecommendationsExcel({
        searchText: searchParams.get("search") || '',
        therapistName: searchParams.get("therapistName") || '',
        date: validateDate(searchParams.get("date")) ? searchParams.get("date") : moment().format("YYYY-MM-DD"),
        orderBy:  searchParams.get("orderBy") || columns[0].sortingKey,
        order:  searchParams.get("order") || 'asc',
        onSuccessCallback
      }))
  }


    const handleSingleValueFilter = (key, value)=>{
      if(value !== searchParams.get(key)){
        searchParams.delete('page')
        searchParams.delete(key)

        let newPair= value ? [[key, value?.trim()]] : [];
        navigate({
          pathname: `${routes.RECOMMENDATIONS_ENDPOINT}`,
          search: `?${createSearchParams([...searchParams.entries(), ...newPair])}`,
        }, {replace: true})
      }
    }


    const onClear = (key)=>{
      searchParams.delete('page')
      searchParams.delete('pageLimit')
      searchParams.delete(key)
      navigate({
        pathname: routes.RECOMMENDATIONS_ENDPOINT,
        search: `?${createSearchParams([...searchParams.entries()])}`,
      }, {replace: true})
    }

    const handleDateChange = (value)=>{
      if(value){
        searchParams.delete('therapistName')
        handleSingleValueFilter("date", moment(value).format('YYYY-MM-DD'))
      }
    }

    useEffect(()=>{
        getTableData()
    },[searchParams])

    useEffect(()=>{
      if(!searchParams.get("date")){
        navigate(`${routes.RECOMMENDATIONS_ENDPOINT}?date=${moment().format("YYYY-MM-DD")}`)
      }else{
        dispatch(getTherapistList({
          date: validateDate(searchParams.get("date")) ? searchParams.get("date") : '',
      }))
      }
    }, [])

    
  return (
    <>
      <div className="recommendations-container fixed-page h-100">
          <div className="container h-100">
            <div className="d-flex justify-content-between">
                <div className="recommendations-heading ms-3 mb-1">
                Therapist Sessions
                </div>
                
            </div>
              <div className="recommendations-content">
                  <div className='recommendations-filter p-3'>
        
                    <div className="data-row row">
                      <div className="col-2 px-1">
                      <SearchBar
                        width={'100%'}
                            onclick={(value)=>{handleSingleValueFilter("search", value)}}
                            value={filter.searchText} 
                            onClear={()=>{onClear("search")}}
                            backgroundColor='#F1F1F1'
                        />
                      </div>
                      <div className="col-2 px-1">

                      </div>
                      <div className="col-2 px-1">

                      </div>
                      <div className="col-2 px-1">
                        <Select
                          isLoading={loadingTherapistlist}
                          className="name-select"
                          classNamePrefix="select"
                          isSearchable={true}
                          name="color"
                          options={loadingTherapistlist ? [] :[{label: 'All', value: ''}, ...(therapistList ? therapistList?.map(item=>({"label": item?.support_staff_name , "value": item?.support_staff_name})) : [] )]}
                          placeholder='Select Therapist'
                          onChange={(e)=>{handleSingleValueFilter("therapistName", e?.value)}}
                          value={therapistList?.find(item=> item.support_staff_name.trim()==filter.therapistName) ? {label: filter.therapistName, value: filter.therapistName} : {label: "All", value: ""}}
                          styles={{
                            container: (baseStyles, state) => ({
                              ...baseStyles,
                              width: '100%',
                              }),
                            }}
                        />
                      </div>
                      <div className="col-2 px-1">
                        <DatePicker
                          onClear={()=>{onClear("date"); }}
                          value={filter.date}
                          hasClearButton={false}
                          onChange={handleDateChange}
                        />
                      </div>
                      <div className="col-2 px-1">
                        <button onClick={downloadTableData} className="download-btn w-100" type='button'> 
                          <span className="btn-icon">
                          {
                              !downloadLoader ?
                              <>
                                  <DownloadIcon fontSize={'19px'}  className='me-2' /> 
                              </>
                              :
                              <CircularProgress size={13} className='mt-1 mr-1' sx={{color: 'white'}} />
                          }
                          </span>
                          Download Excel</button>
                      </div>
                    </div>
                  </div>
                  
                  <RecommendationsTable
                      checkbox={false}
                      columns={columns}
                      loading={loading}
                      data ={recommendations?.data?.map((item, index)=>({
                          name: `${item.first_name || ''} ${item.last_name || ''}`.trim() || '-',
                          gender: item.gender,
                          assign_doctor: item?.assign_doctor || '-',
                          room_no: item?.room_no || 'ABC',
                          support_staff_name: item?.support_staff_name || '-',
                          notes_recommendation: item?.notes_recommendation || '-',
                          session_time: item.check_out ? item.session_time : '-',
                          session_notes: item?.session_notes || '-',
                          session_name: item?.session_name || '-',
                          ...item
                      })) || []}
                      pagination={recommendations?.data?.length}
                      totalCount={recommendations?.total}
                      totalPages={recommendations?.total_pages}
                      start={(recommendations?.current_page_no - 1) * (recommendations?.end-recommendations?.start) + 1}
                      end={(recommendations?.current_page_no - 1) * (recommendations?.end-recommendations?.start) + recommendations?.data?.length}
                      currentPage={recommendations?.current_page_no-1}
                      rowsPerPage={searchParams.get("pageLimit") || 10}
                      filter={filter}
                      getTableData={getTableData}
                  />
                  {!recommendations?.data?.length && !loading && (
                    <div className="text-sm text-[#AAAAAA] my-10 text-center italic">
                      No Records
                    </div>
                  )}
              </div>
          </div>
      </div>
    </>
  )
}

export default Recommendations